import useAppSelector from '../../../store/hooks/useAppSelector'
import { clientContextIsCompanyUserSelector } from '../../clientContext/store/clientContextSelectors'
import { preOrderCheckoutCompanySelector } from '../../preOrder/store/preOrderSelectors'
import { outletListItemSelector } from '../store/outletSelector'

export default function useOverrideMenuTreeId() {
  const outlet = useAppSelector(outletListItemSelector)

  const isCompanyUser = useAppSelector(clientContextIsCompanyUserSelector)
  const isCompanyPreOrder = useAppSelector(preOrderCheckoutCompanySelector)

  if (isCompanyUser || isCompanyPreOrder) {
    return outlet?.anconOrderCompanyMenuTreeId || outlet?.anconOrderMenuTreeId
  }

  return outlet?.anconOrderMenuTreeId
}
